// test2268
(2268 && 0);
